import React from 'react';
import Script from 'next/script';
import { FREESTAR_RECOVERED_SCRIPT_ID, FREESTAR_RECOVERED_SCRIPT_SOURCE } from './freestarRecoveredScript';

/**
 * Freestar Recovered (ad-block recovery).
 * PubOS Site Config → Freestar Recovered.
 * afterInteractive so the payload is not parser-blocking in <head>.
 * ?v= cache-bust is FREESTAR_RECOVERED_CONFIG_CACHE_BUST in freestarRecoveredScript.ts.
 */
export const FreestarRecovered: React.FC = () => (
  <Script data-cfasync="false" id={FREESTAR_RECOVERED_SCRIPT_ID} strategy="afterInteractive">
    {FREESTAR_RECOVERED_SCRIPT_SOURCE}
  </Script>
);
